import React from 'react';

import styled from 'styled-components';

import { STEPPER_STATUS } from '@twicapp/ui/constants/properties';
import Stepper from '@twicapp/ui/components/Stepper';
import Step from '@twicapp/ui/components/Step';
import { useLocation } from 'react-router';
import { EnrollRoutes } from 'utils/routeGenerator';

const Container = styled.div`
  max-width: 880px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 36px;
  background-color: ${({
    theme: {
      colors: {
        background: { primary },
      },
    },
  }) => primary};
`;

const StepHeader = styled.div`
  max-width: 384px;
  margin: auto;
  padding-bottom: 36px;
`;

type StepInfo = {
  label: string;
  step_number: number;
};

const ENROLL_STEPS: StepInfo[] = [
  {
    label: 'Contribution',
    step_number: 1,
  },
  {
    label: 'Review',
    step_number: 2,
  },
];

const currentStep = (path_name: string): number | undefined => {
  switch (path_name) {
    case EnrollRoutes.commuterContribution({}):
      return 1;
    case EnrollRoutes.commuterReview({}):
      return 2;
    case EnrollRoutes.commuterConfirmed():
    default:
      return undefined;
  }
};

const EnrollLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { pathname } = location;
  const current_step = currentStep(pathname);

  return (
    <Container>
      {current_step && (
        <StepHeader>
          <Stepper>
            {ENROLL_STEPS.map(({ label, step_number }) => (
              <Step
                label={label}
                number={step_number}
                key={step_number}
                status={
                  current_step === step_number
                    ? STEPPER_STATUS.ACTIVE
                    : current_step > step_number
                    ? STEPPER_STATUS.COMPLETED
                    : STEPPER_STATUS.INACTIVE
                }
              />
            ))}
          </Stepper>
        </StepHeader>
      )}
      {children}
    </Container>
  );
};

export default EnrollLayout;
